<style lang="scss">
  .footer {
    margin-top: auto;
    position: sticky;
    bottom: 0;
    background: white;
  }

  .divider {
    height: 1px;
    background-color: #eaecf0;
    margin: 0;
    width: 100%;
  }

  .buttons {
    display: flex;
    padding: 12px 24px;
    justify-content: flex-end;
    align-items: center;
    gap: 17px;
    background: white;
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { confirmedStore } from "./stores";

  let { onPurchase, cancel, clientHeight = $bindable(0) } = $props();

  let disabled = $derived(!$confirmedStore);
  let disabledCls = $derived(disabled ? "disabled" : "");

  let buttonProps = $derived({
    class: `flex-1 ${disabledCls}`,
    leadingIcon: "fa-regular fa-cart-shopping",
    kind: "primary",
    size: "large",
    onclick: onPurchase,
    disabled,
  });
</script>

<div class="footer" bind:clientHeight>
  <div class="divider"></div>
  <div class="buttons">
    <Button class="flex-1" kind="ghost-blue" size="large" onclick={cancel}
      >Cancel</Button
    >

    {#if disabled}
      <ButtonWithTooltip {...buttonProps} placement="top">
        Purchase
        <span slot="tooltip"
          >Please check the box to confirm your selection</span
        >
      </ButtonWithTooltip>
    {:else}
      <Button {...buttonProps}>Purchase</Button>
    {/if}
  </div>
</div>
